import { ServiceTier } from '@/constants/user/userServiceTier'

type ServiceTierFlags = Record<ServiceTier, boolean>

/**
 * A simple typing to make using the matchByServiceTier function cleaner to use
 */
type SimpleServiceTierFlags = {
	ecommerce?: boolean
	assistedSales?: boolean
	accountManaged?: boolean
	vip?: boolean
}

const mapToServiceTierFlags = (
	simple: SimpleServiceTierFlags
): ServiceTierFlags => ({
	[ServiceTier.Ecommerce]: simple.ecommerce ?? false,
	[ServiceTier.AssistedSales]: simple.assistedSales ?? false,
	[ServiceTier.AccountManaged]: simple.accountManaged ?? false,
	[ServiceTier.VIP]: simple.vip ?? false,
})

const matchByServiceTier = (
	user: User,
	serviceTiers: SimpleServiceTierFlags
): boolean => {
	if (!user) {
		return false
	}

	const { serviceTier } = user.organisation
	const mappedFlags = mapToServiceTierFlags(serviceTiers)

	return mappedFlags[serviceTier as keyof ServiceTierFlags] === true
}

export default matchByServiceTier
